export const environment = {
  production: false,
  apiUrl: 'https://app-products-api-dev.azurewebsites.net/api'
};
